const rePostnummer = /\d{5}/

module.exports = function normalizeSvensktPostnummer(input) {
  const match = rePostnummer.exec(input.replace(/\s/g, ''))

  if (!match) return input

  return match[0]
}
